import { type FC } from 'react';
import { useSelector } from 'react-redux';

import { LayoutBlock } from 'shared/components/LayoutBlock';
import { Banner } from 'shared/components/Promos';
import { mortgageBannerSelector } from 'shared/selectors/mortgageBanner';

export const Promos: FC = () => {
  const banner = useSelector(mortgageBannerSelector);

  if (!banner?.image) {
    return null;
  }

  return (
    <LayoutBlock id="promos">
      <Banner disclaimer={banner.disclaimer} hitUrl={banner.hitUrl} image={banner.image} key={0} />
    </LayoutBlock>
  );
};
